import React, {useEffect, useState, Fragment} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import { useHistory } from 'react-router-dom';
import { County } from '../interfaces';
import {
    openDropDown,
    setWhereFilter,
    setKindFilter,
    setDateFilter,
    startFilteredLoad,
    endFilteredLoad  } from '../../redux/actions';

import DatePicker from 'react-datepicker';
import et from 'date-fns/locale/et';

import './drop.scss'
import 'react-datepicker/dist/react-datepicker.css';
import {filterBuilder, urlBuilder} from '../../helpers/url-builder';
import {RootState} from '../../redux/reducers';
import {isFiltersEmpty} from '../../helpers/utils';



const CheckMark = () => {
    return <svg width="16" height="16" x="0" y="0" viewBox="0 0 448.8 448.8">
    <g>

        <g id="done">
        <polygon points="142.8,323.85 35.7,216.75 0,252.45 142.8,395.25 448.8,89.25 413.1,53.55   " fill="#222328" data-original="#000000"/>
        </g>

     </g></svg>

}
function DropDownArea (props:any) {
    const { counties, dropDownShow, filters } = props;
    const [selectedCounty, setSelectedCounty] = useState<string|null>(null);
    // @ts-ignore
    const userProfile = useSelector((state:RootState) => state.userProfile)
    const [currentProfile, setCurrentProfile] = useState(userProfile)
    const dispatch = useDispatch();
    const history = useHistory();
//    const currentRef = useRef(null);

    const [selectedCategory, setSelectedCategory] = useState<string|null>(filters.kind);
    const [startDate, setStartDate] = useState(new Date());

    useEffect(() => {
        if (filters.kind !== selectedCategory) {
            setSelectedCategory(filters.kind)
        }
    }, [filters])

    const noUrlFilters = () => {
        const url = window.location.href
        if (url.indexOf('/event/') < 0 && url.indexOf('/places/') < 0) {
            return true
        }
        return false
    }

    useEffect(() => {

        if (isFiltersEmpty(filters)) {
            if(userProfile.username !== currentProfile.username) {
                setCurrentProfile(userProfile)
                if (userProfile.city && noUrlFilters()) {
                    history.push(`/events/city=${userProfile.city}`)
                }
            }
        }

    }, [userProfile])

    const addCityFilter = (e: React.MouseEvent<HTMLElement>) => {

        const element = e.currentTarget.getAttribute('data-element');
        const type = e.currentTarget.getAttribute('data-type')
        if (type === 'county') {
            if (element !== selectedCounty) {
                setSelectedCounty(element);
                const byId = document.getElementById(`county_${element}`);
                const tm = setTimeout(()=> {
                    byId?.scrollIntoView();
                    clearTimeout(tm);
                }, 0)
                return false;
            }
        }
        const url = urlBuilder(filterBuilder(filters, `${type}=${element}`, 'where'))
        // console.log('DropdownArea::addCityFilter push')
        history.push(url);

        dispatch(startFilteredLoad());
        dispatch(setWhereFilter(`${type}=${element}`));
        dispatch(openDropDown(false));
    }

    const addCategoryFilter = (e: React.MouseEvent<HTMLElement>) => {
        //
        // const element = e.currentTarget.getAttribute('data-element');
        //history.push(ROOT_ROUTE || '/');
        dispatch(startFilteredLoad());
        let filter = selectedCategory?.startsWith('category=') ? selectedCategory : `category=${selectedCategory}`;
        //history.push(urlBuilder(filter));
        const url = urlBuilder(filterBuilder(filters, filter, 'kind'))
        // console.log('DropdownArea::addCategoryFilter push')
        history.push(url);
        //history.push('/');
        dispatch(setKindFilter(filter));
        dispatch(openDropDown(false));
    }

    const addSelectedCategory = (e: React.MouseEvent<HTMLElement>) => {
        const element = e.currentTarget.getAttribute('data-element');
        let selected: string | null = ''
        const selectedArray = selectedCategory?.split(';') || []

        if (element) {
            if (selectedArray?.length && selectedArray.includes(element)) {
                if (selectedArray.length === 1) {
                    selected = ''
                } else {
                    selectedArray.splice(selectedArray.indexOf(element),1)
                    selected = selectedArray.join(';')
                }
            } else {
                selectedArray.push(element)
                selected = selectedArray.join(';')
            }
        }
        setSelectedCategory(selected);
    }

    const addDateFilter = (d:Date) => {
        //history.push(urlBuilder(`date=${d.toISOString().split('T')[0]}`));
        const url = urlBuilder(filterBuilder(filters, `date=${d.toISOString().split('T')[0]}`, 'date'))
//        console.log('DropdownArea::addDateFilter push')
        history.push(url);
//        history.push('/');
        dispatch(startFilteredLoad());
        dispatch(setDateFilter(`date=${d.toISOString().split('T')[0]}`));
        dispatch(openDropDown(false));
        setStartDate(d)
    }

    const filterCityName = (name: string): string => {
        if (name === 'Rakvere vald') {
            return name;
        }
        if (name === 'Tartu vald') {
            return name;
        }
        if (name === 'Viljandi vald') {
            return name
        }
        return name.replace('vald','')
    }

    const renderCountyList = (counties: County[]) => {
        if (!counties.length) {
            return []
        }
        return counties.map((county: County, idx: number) => {
            let className = "element-item" + (county.className ? ` ${county.className}` : "")
            if (county.id === selectedCounty) {
                className = `${className} active`
            }
            if (county.parent === selectedCounty) {
                className = `${className} open`
            }
            if (!counties[idx+1]) {
                className = `${className} last`
            } else if(counties[idx+1].parent !== selectedCounty) {
                className = `${className} last`
            }

            // @ts-ignore
            return county.className ? <div
                key={idx}
                data-element={county.id}
                data-type={county.className?'county':'city'}
                onClick={addCityFilter}
                id={`county_${county.id}`}
                className={className}>
                    {county.name}
                </div> : county.parent === selectedCounty ? <div
                key={idx}
                data-element={county.id}
                data-type={county.className?'county':'city'}
                onClick={addCityFilter}
                id={`city_${county.id}`}
                className={className}>
                {filterCityName(county.name)}
            </div>: null
        })
    }

    const renderCategoryList = () => {
        const { categories } = props;
        if (!categories || categories.code !== 1) {
            return null
        }
        const arr = categories.data.categories;


        return arr.map((element: any, idx: number) => {
            const thisSelected = selectedCategory?.includes(element.slug)
            let className = `element-item ${thisSelected?' selected':''}`
            return <div
                key={idx}
                data-element={element.slug}
                onClick={addSelectedCategory}
                className={className}>
                    {element.name}
                {thisSelected && <div className='check-mark'>
                    <CheckMark />
                </div>}
                </div>
        })
    }

    const renderDatePicker = () => {

        const minDate = new Date()
        return(<div>
            <DatePicker
                selected={startDate}
                onChange={(date: Date) => addDateFilter(date)}
                onSelect={(d) => {
                   // console.log('d',d);
                }}
                locale={et}
                minDate={minDate}
                inline
            />
        </div>)
    }

    return (
        <Fragment>
            { !!dropDownShow.dropDownShow && dropDownShow.type === 'counties' &&
            <div className="header dropdown-area">
                { renderCountyList(counties) }
                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </div>
            }
            { !!dropDownShow.dropDownShow && dropDownShow.type === 'categories' &&
            <div className="header dropdown-area">
                <div>Vali üks või mitu kategooriat</div>
                <div className="green-btn" onClick={addCategoryFilter}>OK</div>
                { renderCategoryList() }
            </div>
            }
            { !!dropDownShow.dropDownShow && dropDownShow.type === 'date' &&
            <div className="header dropdown-area">
                { renderDatePicker() }
            </div>
            }
        </Fragment>

    );
}

const mapStateToProps = (state: any) => {

    const { counties, categories, dropDownShow, loadingFilters, filters } = state;
    return { counties, categories, dropDownShow, loadingFilters, filters };
};

export default connect(mapStateToProps, {startFilteredLoad, endFilteredLoad})(DropDownArea);

